window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.project_group_setup_modal = window.locales.am.project_group_setup_modal || {};window.locales.am.project_group_setup_modal = {...window.locales.am.project_group_setup_modal, ...{
    "member_search_page_title": "የእርስዎን ፕሮጀክት ቡድን ይፍጠሩ",
    "review_and_confirm_page_title": "ቡድኑን ይመልከቱ እና ያረጋግጡ",
    "success_page_title": "🎉 ቡድን ተሰበሰበ!",
    "footnote": "ስለ ቡድን ስራው ጥያቄዎች ካሉዎት እባክዎ ወደ {email} ኢሜይል ይላኩ።"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.project_group_setup_modal = window.locales.ar.project_group_setup_modal || {};window.locales.ar.project_group_setup_modal = {...window.locales.ar.project_group_setup_modal, ...{
    "member_search_page_title": "قم بإنشاء مجموعة مشروعك",
    "review_and_confirm_page_title": "مراجعة وتأكيد المجموعة",
    "success_page_title": "🎉 تم تجميع الفريق!",
    "footnote": "إذا كان لديك أسئلة حول إعداد المجموعة، يرجى إرسال بريد إلكتروني إلى {email}."
}
};window.locales.en = window.locales.en || {};window.locales.en.project_group_setup_modal = window.locales.en.project_group_setup_modal || {};window.locales.en.project_group_setup_modal = {...window.locales.en.project_group_setup_modal, ...{
    "member_search_page_title": "Create Your Project Group",
    "review_and_confirm_page_title": "Review & Confirm Group",
    "success_page_title": "🎉 Team Assembled!",
    "footnote": "If you have questions about group setup, please email {email}."
}
};window.locales.es = window.locales.es || {};window.locales.es.project_group_setup_modal = window.locales.es.project_group_setup_modal || {};window.locales.es.project_group_setup_modal = {...window.locales.es.project_group_setup_modal, ...{
    "member_search_page_title": "Crea tu grupo de proyecto",
    "review_and_confirm_page_title": "Revisar y confirmar grupo",
    "success_page_title": "🎉 ¡Equipo formado!",
    "footnote": "Si tienes preguntas sobre la configuración del grupo, envía un correo a {email}."
}
};window.locales.it = window.locales.it || {};window.locales.it.project_group_setup_modal = window.locales.it.project_group_setup_modal || {};window.locales.it.project_group_setup_modal = {...window.locales.it.project_group_setup_modal, ...{
    "member_search_page_title": "Crea il tuo gruppo di progetto",
    "review_and_confirm_page_title": "Rivedi e conferma gruppo",
    "success_page_title": "🎉 Squadra assemblata!",
    "footnote": "Se hai domande sulla configurazione del gruppo, invia un'email a {email}."
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.project_group_setup_modal = window.locales.zh.project_group_setup_modal || {};window.locales.zh.project_group_setup_modal = {...window.locales.zh.project_group_setup_modal, ...{
    "member_search_page_title": "创建您的项目组",
    "review_and_confirm_page_title": "审核并确认组",
    "success_page_title": "🎉 团队组建完成！",
    "footnote": "如果您对组设置有疑问，请发送电子邮件至{email}。"
}
};